import { render, staticRenderFns } from "./DiscardProductDialog.vue?vue&type=template&id=054bdb8d"
import script from "./DiscardProductDialog.vue?vue&type=script&lang=ts"
export * from "./DiscardProductDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports